import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const RegisterWidgetSection = memo(({ theme, sectionId }) => {
  const RegisterWidgetSectionLayout = dynamic(() => import(/* webpackChunkName: 'RegisterWidgetSectionLayout' */ `../../../../../containers/home-page/views/sections/register-widget/layouts/${theme.layout}`))

  return (
    <RegisterWidgetSectionLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

RegisterWidgetSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default RegisterWidgetSection
